import { PermissionRolesEnum } from "../enums/profiles";

export interface MenuItem {
	label: string;
	icon: string;
	path?: string;
	requiredRoleType?: PermissionRolesEnum;
	children?: MenuItem[];
}

export const garanttiMenuStructure: MenuItem[] = [
	{
		label: "DashBoard",
		icon: "dashboard_outlined",
		path: "/dashboard",
	},
	{
		label: "Cadastros",
		icon: "people_outline",
		children: [
			{ label: "Clientes", icon: "people_outline", path: "/clientes", requiredRoleType: PermissionRolesEnum.ClientsDashboard },
			{ label: "Contratos", icon: "description_outlinedicon", path: "/clientes/contratos", requiredRoleType: PermissionRolesEnum.ContractsMenu },
			{ label: "Usuários", icon: "person_outlinedicon", path: "/usuarios", requiredRoleType: PermissionRolesEnum.UsersDashboard },
			{ label: "Permissões", icon: "admin_panel_settings_outlined", path: "/permissoes", requiredRoleType: PermissionRolesEnum.PermissionsMenu },
			{ label: "BlackList", icon: "group_remove_outlinedicon", path: "/blacklist", requiredRoleType: PermissionRolesEnum.PeopleMenu },
		],
	},
	{
		label: "Seguro/Garantia",
		icon: "security_outline",
		children: [
			{
				label: "Garantia Locatícia",
				icon: "verified_user",
				children: [
					{ label: "Análises", icon: "insert_chart_outlinedicon", path: "/analises", requiredRoleType: PermissionRolesEnum.AnalysisDashboard },
					{ label: "Minhas Garantias", icon: "security_outline", path: "/garantias", requiredRoleType: PermissionRolesEnum.WarrantiesMenu },
				],
			},
			{ label: "Incêndio", icon: "whatshot_outlinedicon", path: "/incendio", requiredRoleType: PermissionRolesEnum.FireMenu },
			{ label: "Capitalização", icon: "image_outlined", path: "/capitalizacao", requiredRoleType: PermissionRolesEnum.CapitalizationMenu },
		],
	},
	{
		label: "Financeiro",
		icon: "monetization_onicon",
		children: [
			{ label: "Repasses", icon: "price_check_outlinedicon", path: "/repasses", requiredRoleType: PermissionRolesEnum.ComissionMenu },
			{ label: "Financeiro", icon: "monetization_onicon", path: "/billet", requiredRoleType: PermissionRolesEnum.FinancialMenu },
			{ label: "Borderô", icon: "payments_outlinedicon", path: "/bordero", requiredRoleType: PermissionRolesEnum.FinancialMenu },
		],
	},
	{
		label: "Relatórios e Gráficos",
		icon: "assignment_outlinedicon",
		children: [
			{ label: "Relatórios", icon: "assignment_outlinedicon", path: "/relatorios", requiredRoleType: PermissionRolesEnum.ReportsMenu },
			{ label: "Gráficos", icon: "equalizer_outlinedicon", path: "/graficos", requiredRoleType: PermissionRolesEnum.ChartsMenu },
		],
	},
	{
		label: "Sinistro",
		icon: "notifications_noneoutlinedicon",
		children: [
			{ label: "Sinistros", icon: "notifications_noneoutlinedicon", path: "/sinistros", requiredRoleType: PermissionRolesEnum.SinisterMenu },
			{ label: "Cobrança/Jurídico", icon: "price_check_outlinedicon", path: "/sinistros/cobranca", requiredRoleType: PermissionRolesEnum.CreditRecoveryMenu },
			{ label: "Acordos", icon: "assignment_turned_in_outlinedicon", path: "/sinistros/acordos", requiredRoleType: PermissionRolesEnum.AgreementsMenu },
			{
				label: "Controle de Cobranças",
				icon: "payments_outlinedicon",
				path: "/sinistros/controle-cobranca",
				requiredRoleType: PermissionRolesEnum.CollectionControlMenu,
			},
		],
	},
	{ label: "Assinaturas", icon: "draw_outlinedicon", path: "/assinaturas", requiredRoleType: PermissionRolesEnum.SignatureMenu },
	{
		label: "Outros",
		icon: "build_outlinedicon",
		children: [
			{ label: "Documentos para Download", icon: "info_outlinedicon", path: "/gerais", requiredRoleType: PermissionRolesEnum.GeneralConditionsMenu },
			{ label: "Ferramentas", icon: "build_outlinedicon", path: "/tools", requiredRoleType: PermissionRolesEnum.PeopleMenu },
			{ label: "Gestão de Banners", icon: "image_outlined", path: "/banners", requiredRoleType: PermissionRolesEnum.BannerMenu },
			{ label: "Fila de Processamento", icon: "sync_outlinedicon", path: "/integrador", requiredRoleType: PermissionRolesEnum.IntegratorMenu },
		],
	},
];

export const imobMenuStructure: MenuItem[] = [
	{
		label: "DashBoard",
		icon: "dashboard_outlined",
		path: "/dashboard",
	},
	{
		label: "Cadastros",
		icon: "people_outline",
		children: [
			{ label: "Perfil", icon: "people_outline", path: "/clientes", requiredRoleType: PermissionRolesEnum.ClientsDashboard },
			{ label: "Contratos", icon: "description_outlinedicon", path: "/clientes/contratos", requiredRoleType: PermissionRolesEnum.ContractsMenu },
			{ label: "Usuários", icon: "person_outlinedicon", path: "/usuarios", requiredRoleType: PermissionRolesEnum.UsersDashboard },
		],
	},
	{
		label: "Seguros",
		icon: "security_outline",
		children: [
			{
				label: "Fiança",
				icon: "verified_user",
				children: [
					{ label: "Análises", icon: "insert_chart_outlinedicon", path: "/analises", requiredRoleType: PermissionRolesEnum.AnalysisDashboard },
					{ label: "Garantias", icon: "security_outline", path: "/garantias", requiredRoleType: PermissionRolesEnum.WarrantiesMenu },
				],
			},
			{ label: "Incêndio", icon: "whatshot_outlinedicon", path: "/incendio", requiredRoleType: PermissionRolesEnum.FireMenu },
			{ label: "Capitalização", icon: "image_outlined", path: "/capitalizacao", requiredRoleType: PermissionRolesEnum.CapitalizationMenu },
		],
	},
	{ label: "Assinaturas", icon: "draw_outlinedicon", path: "/assinaturas", requiredRoleType: PermissionRolesEnum.SignatureMenu },
	{
		label: "Sinistro",
		icon: "notifications_noneoutlinedicon",
		children: [
			{ label: "Sinistros", icon: "notifications_noneoutlinedicon", path: "/sinistros", requiredRoleType: PermissionRolesEnum.SinisterMenu },
			{ label: "Cobrança/Jurídico", icon: "price_check_outlinedicon", path: "/sinistros/cobranca", requiredRoleType: PermissionRolesEnum.CreditRecoveryMenu },
			{ label: "Acordos", icon: "assignment_turned_in_outlinedicon", path: "/sinistros/acordos", requiredRoleType: PermissionRolesEnum.AgreementsMenu },
			{
				label: "Controle de Cobranças",
				icon: "payments_outlinedicon",
				path: "/sinistros/controle-cobranca",
				requiredRoleType: PermissionRolesEnum.CollectionControlMenu,
			},
		],
	},
	{
		label: "Outros",
		icon: "build_outlinedicon",
		children: [{ label: "Documentos para Download", icon: "info_outlinedicon", path: "/gerais", requiredRoleType: PermissionRolesEnum.GeneralConditionsMenu }],
	},
];
